













































import {
  Vue,
  Component,
  Prop,
  Inject
} from "@/shared/vuepack";
import moment from "moment";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import { formatCurrency } from "@/shared/currency";
import { useEmployerPayrollStore } from "@/employer/store/employerPayroll";

@Component({
  components: {
    Button
  }
})
export default class EmployeePayrollRowView extends Vue {
  employerPayrollStore = useEmployerPayrollStore();

  @Inject()
  $validator: Validator;

  @Prop() contribution: any; // EmployeeContribution;

  @Prop() isLocked: boolean;

  showConfirmModal = false;

  formatCurrency = formatCurrency;

  get formattedLastModified () {
    return moment(this.contribution.lastModified).format("MMM DD, YYYY");
  }

  get changeTooltip () {
    if (this.contribution.modifiedByPayrollRecalculation) {
      return "Updated automatically by the system";
    }
    if (this.contribution.isEmployeeModified) {
      return "Employee has reset their contribution on this payroll date";
    }
    if (this.contribution.employerModifiedBy) {
      const employerName = this.contribution.employerModifiedBy;
      return `${employerName.firstName} ${employerName.lastName} reset the employee amount for this payroll date`;
    }
    return "No contribution modifications recorded for this date";
  }

  enableEdit () {
    this.employerPayrollStore.setSelectedEmployeeId(this.contribution.employeeId);
  }
}
